import { render, staticRenderFns } from "./SideBarPatient.vue?vue&type=template&id=03a5c4d3&scoped=true&"
import script from "./SideBarPatient.vue?vue&type=script&lang=ts&"
export * from "./SideBarPatient.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarPatient.vue?vue&type=style&index=0&id=03a5c4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5c4d3",
  null
  
)

export default component.exports